import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();

  const carouselImages = [
    {
      url: 'https://images.unsplash.com/photo-1649930308240-0a4ae421ff77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxmYXNoaW9uJTIwd29tYW4lMjBtb2RlbHxlbnwwfHx8fDE3NjQyMjE0OTZ8MA&ixlib=rb-4.1.0&q=85',
      label: 'Women Fashion'
    },
    {
      url: 'https://images.unsplash.com/photo-1642886512785-b5fee9faad7f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxmYXNoaW9uJTIwbWFuJTIwbW9kZWx8ZW58MHx8fHwxNzY0MjIxNTAxfDA&ixlib=rb-4.1.0&q=85',
      label: 'Men Fashion'
    },
    {
      url: 'https://images.unsplash.com/photo-1695262620869-fedab63bcc41?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxnaXJsJTIwY2hpbGQlMjBmYXNoaW9ufGVufDB8fHx8MTc2NDIyMTUxMnww&ixlib=rb-4.1.0&q=85',
      label: 'Girls Fashion'
    },
    {
      url: 'https://images.unsplash.com/photo-1695336555985-6abf3c053ec2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxib3klMjBjaGlsZCUyMGZhc2hpb258ZW58MHx8fHwxNzY0MjIxNTA3fDA&ixlib=rb-4.1.0&q=85',
      label: 'Boys Fashion'
    }
  ];

  const [currentSlide, setCurrentSlide] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [carouselImages.length]);

  const features = [
    {
      icon: '🎨',
      title: 'AI-Powered Try-On',
      description: 'Experience FITTTY technology that preserves your face and fits garments naturally',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    },
    {
      icon: '⚡',
      title: 'Instant Results',
      description: 'Get photorealistic try-on images in 5-17 seconds with professional quality',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
    },
    {
      icon: '👔',
      title: 'Curated Brands',
      description: 'Browse garments from top brands including Zara, H&M, Nike, Adidas, and more',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
    },
    {
      icon: '💾',
      title: 'Save & Share',
      description: 'Download your favorite looks and keep a history of all your virtual try-ons',
      gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)'
    }
  ];

  return (
    <div className="landing-page">
      {/* Header */}
      <header className="site-header">
        <div className="logo-container">
          <img 
            src="https://customer-assets.emergentagent.com/job_5570680c-3f90-44c2-8f62-b2c05e92211c/artifacts/6tbkty9m_FITTTY-LOGO.png" 
            alt="FITTTY.AI" 
            className="landing-logo-image"
          />
        </div>
        <div className="header-actions">
          {isAuthenticated ? (
            <>
              <button className="header-login" onClick={() => navigate('/tryon')}>
                Go to App
              </button>
              <button className="header-cta" onClick={() => {
                logout();
              }}>
                Logout
              </button>
            </>
          ) : (
            <>
              <button className="header-login" onClick={() => navigate('/login')}>
                Login
              </button>
              <button className="header-cta" onClick={() => navigate('/signup')}>
                Get Started
              </button>
            </>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="gradient-text">Try Before You Buy</span>
            <br />
            With AI Virtual Fitting
          </h1>
          <p className="hero-subtitle">
            FITTTY brings the future of online shopping to you. Upload your photo,
            select from curated brands, and see how clothes look on YOU - instantly.
          </p>
          <button className="cta-button" onClick={() => navigate('/signup')}>
            Start Virtual Try-On
            <span className="arrow">→</span>
          </button>
          <p className="powered-by">Powered by FITTTY Technology</p>
        </div>
        
        {/* Carousel */}
        <div className="hero-carousel">
          <div className="carousel-container">
            {carouselImages.map((img, index) => (
              <div
                key={index}
                className={`carousel-slide ${
                  index === currentSlide ? 'active' : ''
                }`}
                style={{
                  backgroundImage: `url(${img.url})`,
                }}
              >
                <div className="carousel-label">{img.label}</div>
              </div>
            ))}
          </div>
          <div className="carousel-dots">
            {carouselImages.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <h2 className="section-title">Why Choose FITTTY?</h2>
        <p className="section-subtitle">Powerful features for the perfect virtual try-on experience</p>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon-wrapper" style={{ background: feature.gradient }}>
                <div className="feature-icon">{feature.icon}</div>
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <h2 className="section-title">How FITTTY Works</h2>
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Upload Your Photo</h3>
            <p>Take or upload a clear full-body photo</p>
          </div>
          <div className="step-arrow">→</div>
          <div className="step">
            <div className="step-number">2</div>
            <h3>Browse Catalog</h3>
            <p>Filter by brand, category, or style</p>
          </div>
          <div className="step-arrow">→</div>
          <div className="step">
            <div className="step-number">3</div>
            <h3>See Yourself</h3>
            <p>Get realistic virtual try-on in seconds</p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-number">16+</div>
            <div className="stat-label">Curated Items</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">8</div>
            <div className="stat-label">Top Brands</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">5-17s</div>
            <div className="stat-label">Generation Time</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">100%</div>
            <div className="stat-label">Face Preserved</div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <h2>Ready to Transform Your Shopping Experience?</h2>
        <p>Join FITTTY and discover how clothes look on you before buying</p>
        <button className="cta-button-large" onClick={() => navigate('/signup')}>
          Get Started Free
        </button>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-brand">
            <img 
              src="https://customer-assets.emergentagent.com/job_5570680c-3f90-44c2-8f62-b2c05e92211c/artifacts/6tbkty9m_FITTTY-LOGO.png" 
              alt="FITTTY.AI" 
              className="footer-logo"
              style={{ width: '120px', height: 'auto' }}
            />
          </div>
          <div className="footer-links">
            <div className="footer-section">
              <h4>Product</h4>
              <a href="/tryon">Virtual Try-On</a>
              <a href="#features">Features</a>
            </div>
            <div className="footer-section">
              <h4>Technology</h4>
              <p>AI-Powered Virtual Try-On</p>
              <p>tryon-v1.6 Model</p>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2025 FITTTY. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;